<template>
  <div class="pbpoint" :class="{'active':active}">
    <div class="pbpoint__point" :class="{'active':active}">
      <div class="pbpoint__point-inner">
        <slot />
      </div>
    </div>
    <div class="pbpoint__strip" :class="{'pbpoint__strip_white': white}">
      <div class="pbpoint__text" ref="text" :style="`width: ${textWidth}`">{{ text }}</div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data: () => ({
    mounted: false,
    textWidth: 0
  }),
  mounted() {
    this.mounted = true
  },
  unmounted() {
    this.mounted = false
  },
  props: {
    text: { type: String, default: '' },
    active: { type: Boolean, default: false },
    white: { type: Boolean, default: false },
  },
  methods: {
    updateWidth() {
      if (this.status) 
        this.textWidth = this.$refs.text.scrollWidth + 'px'
      else
        this.textWidth = 0
    }
  },
  computed: {
    ...mapState(['show']),
    status() {
      return (this.mounted && this.active & this.show)
    }
  },
  watch: {
    status(v, old) {
      if (v != old)
        this.$nextTick(this.updateWidth)
    }
  }
}
</script>

<style lang="sass" scoped>
.pbpoint
  --size: 56px
  display: flex
  letter-spacing: globalvars.$normspacing
  &__point
    position: relative
    z-index: 1
    width: var(--size)
    height: var(--size)
    display: flex
    justify-content: center
    align-items: center
    background: colors.$newred
    border-radius: 9999px
    color: colors.$notred
    font-family: globalvars.$font5
    font-weight: 500
    font-size: 24px
    line-height: 28px
    flex-shrink: 0
    transition: background-color .3s ease-out
    &-inner
      margin-top: -1px
    &:not(.active)
      background: colors.$moar_silver_for_the_god_of_silver2
  &__strip
    margin-left: calc(var(--size) * (-1))
    border-radius: 64px
    background: colors.$anothersilver
    padding: 17px 24px 15px
    min-width: var(--size)
    &_white
      background: colors.$mainbg
  &__text
    text-indent: var(--size)
    font-size: 15px
    line-height: 24px
    color: colors.$gray5
    white-space: nowrap
    overflow: hidden
    transition: width .4s ease
  @include from(820px)
    width: 100%
    min-width: 100%
    align-items: center
    &:not(:first-child)
      margin-left: -100%
    &:not(.active)
      opacity: 0
      pointer-events: none
    &__strip
      padding-top: 15px
      padding-bottom: 13px
      align-self: stretch
      display: flex
      align-items: center
      padding-left: 10px
    &__text
      flex-grow: 1
      line-height: 1
      width:  auto !important
      max-width: 100%
      white-space: normal
      margin-right: 0
      text-indent: 0
      padding-left: var(--size)
</style>